import axios from "axios";
import { Base_URL } from "../url";

export const saveItemGroup = async (itemGroupData) => {
  try {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const userId = userDetails?.userId; 
    const response = await axios.post(
      `${Base_URL}/ItemGroupMaster/CreateItemGroup?UserName=${userId}`,
      itemGroupData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving item group!";
  }
};

export const getAllItemTypes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/ItemTypeMaster/GetAllItemTypes`);
    return response.data.map(item => ({
      code: item.code,
      description: item.description
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching item types!";
  }
};